"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Redo_exports = {};
__export(Redo_exports, {
  default: () => Redo_default
});
module.exports = __toCommonJS(Redo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.1484 4.76172C15.0443 4.67057 14.9922 4.5599 14.9922 4.42969C14.9922 4.28646 15.0443 4.16276 15.1484 4.05859C15.2396 3.96745 15.3568 3.92188 15.5 3.92188C15.6432 3.92188 15.7604 3.96745 15.8516 4.05859L18.5078 6.71484C18.6901 6.89714 18.7812 7.11849 18.7812 7.37891C18.7812 7.6263 18.6901 7.83464 18.5078 8.00391L15.8516 10.6602C15.7604 10.7643 15.6432 10.8164 15.5 10.8164C15.3568 10.8164 15.2396 10.7643 15.1484 10.6602C15.0443 10.569 14.9922 10.4518 14.9922 10.3086C14.9922 10.1654 15.0443 10.0482 15.1484 9.95703L17.2773 7.82812H7.14062C6.125 7.82812 5.25911 8.1862 4.54297 8.90234C3.82682 9.61849 3.46875 10.4844 3.46875 11.5C3.46875 12.5156 3.82682 13.3815 4.54297 14.0977C5.25911 14.8138 6.125 15.1719 7.14062 15.1719H12.5508C12.694 15.1719 12.8112 15.224 12.9023 15.3281C13.0065 15.4193 13.0586 15.5299 13.0586 15.6602C13.0586 15.8034 13.0065 15.9271 12.9023 16.0312C12.8112 16.1224 12.694 16.168 12.5508 16.168H7.14062C6.48958 16.168 5.88411 16.0443 5.32422 15.7969C4.7513 15.5495 4.25 15.2174 3.82031 14.8008C3.40365 14.3841 3.07812 13.8893 2.84375 13.3164C2.59635 12.7435 2.47266 12.138 2.47266 11.5C2.47266 10.862 2.59635 10.2565 2.84375 9.68359C3.07812 9.11068 3.40365 8.61589 3.82031 8.19922C4.25 7.78255 4.7513 7.45052 5.32422 7.20312C5.88411 6.95573 6.48958 6.83203 7.14062 6.83203H17.2188L15.1484 4.76172Z",
      fill: "currentColor"
    }
  )
);
const SvgRedo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Redo_default = SvgRedo;
